import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { useMemo, useState } from 'react'
import { daysAgo, eventsTableQuery, today, type Period } from '../api/securitee'
import { Content } from '../ui/Shell'
import { DataTable, useTableState } from '../ui/DataTable'
import { eventColumns } from './columns'
import { PeriodFilter } from './DevicesPage'

/**
 * Securitee::events - fisierele transferate pe firma (`it_securitee_files`),
 * pe perioada (implicit ultimele 7 zile; in portalul vechi numai azi, pana la alegerea din
 * calendar), tabelul `#securiteeEvents` cu `EventsModel`.
 */
export const TABLE_ID = 'securiteeEvents'

export function SecuriteeEventsPage() {
  // ultimele 7 zile: "numai azi" lasa ecranul gol cand nu s-a copiat nimic azi
  const [period, setPeriod] = useState<Period>(() => ({ from: daysAgo(6), to: today() }))
  const [state, setState] = useTableState(TABLE_ID, { start: 0, length: 25, order: { column: 7, dir: 'desc' }, search: '' })
  const columns = useMemo(() => eventColumns(), [])
  const orderColumn = columns.find((c) => c.index === state.order.column) ?? columns[7]!
  const query = useQuery({
    ...eventsTableQuery({ draw: 1, start: state.start, length: state.length, orderColumn: orderColumn.index, orderName: orderColumn.name ?? '', orderDir: state.order.dir, search: state.search, ...period }),
    placeholderData: keepPreviousData,
  })

  return (
    <Content>
      <div id="content">
        <DataTable
          id={TABLE_ID}
          columns={columns}
          rows={query.data?.data ?? []}
          total={query.data?.recordsTotal ?? 0}
          fetching={query.isFetching}
          error={query.isError ? (query.error as Error).message : null}
          onRetry={() => void query.refetch()}
          state={state}
          onState={setState}
          rowId={(r) => String(r.DT_RowId)}
          headerButtons={<PeriodFilter period={period} onChange={setPeriod} />}
        />
      </div>
    </Content>
  )
}
